import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { User as UserIcon } from '@linktivity/link-icons';
import { Link } from '@linktivity/link-ui';
import { ga4AccountEntryState } from '@link/share/vendors';
import { useHeaderContext } from './context';
import { AccountProps } from './header.types';
import User from './User';
import styles from './header.module.css';

const LOGIN_LINK_STATE = ga4AccountEntryState('header');

/** The login link, or the user menu once logged in. */
const Account: FC<AccountProps> = ({ loggedIn, logout, isPasswordAuth }) => {
  const { t, i18n } = useTranslation();
  const { closeMobileMenu } = useHeaderContext();

  if (loggedIn) {
    return <User logout={logout} isPasswordAuth={isPasswordAuth} />;
  }

  return (
    <Link
      to={`/${i18n.language}/login`}
      state={LOGIN_LINK_STATE}
      className={styles.navButton}
      onClick={closeMobileMenu}
    >
      <UserIcon className={styles.navIcon} />
      <span className={styles.text}>{t('share.login.button')}</span>
    </Link>
  );
};

export default Account;
